import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {styled} from "styled-components";

const Scrim = styled.div<{$visible: boolean}>`
  position: absolute;
  inset: 0;
  background: rgba(15, 18, 24, 0.18);
  opacity: ${p => (p.$visible ? 1 : 0)};
  pointer-events: ${p => (p.$visible ? "auto" : "none")};
  transition: opacity 0.22s;
  z-index: 10;
`;

const Panel = styled.div<{$open: boolean}>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 92%;
  background: #fff;
  box-shadow: -8px 0 24px rgba(15, 18, 24, 0.18);
  transform: translateX(${p => (p.$open ? "0" : "100%")});
  transition: transform 0.26s cubic-bezier(0.2, 0.7, 0.3, 1);
  display: flex;
  flex-direction: column;
  z-index: 11;
`;

const PanelHeader = styled.header`
  flex: 0 0 auto;
  height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  border-bottom: 1px solid #e5e7eb;
`;

const PanelTitle = styled.span`
  font-weight: 700;
  font-size: 15px;
  flex: 1;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;

const PanelBody = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 14px 16px;
  font-size: 13px;
  line-height: 1.5;
  color: #1f2937;

  pre,
  code {
    white-space: pre-wrap;
    overflow-wrap: break-word;
  }
`;

interface ReasoningDrawerProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  message: any;
  onClose: () => void;
}

export function ReasoningDrawer({message, onClose}: ReasoningDrawerProps) {
  const open = Boolean(message);
  return (
    <>
      <Scrim $visible={open} onClick={onClose} />
      <Panel $open={open}>
        <PanelHeader>
          <PanelTitle>Reasoning</PanelTitle>
          <CloseButton onClick={onClose} aria-label="Close reasoning panel">
            <svg
              viewBox="0 0 24 24"
              width="18"
              height="18"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </CloseButton>
        </PanelHeader>
        <PanelBody>
          {message && (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {message.metadata?.detailed_response ?? ""}
            </ReactMarkdown>
          )}
        </PanelBody>
      </Panel>
    </>
  );
}
